import styled from "@emotion/styled";

export interface LateManifestStopsContentProps {
  lateManifests: Array<{manifestDriverId: number; driverName: string}>;
}

const LateManifestStopsContent = ({lateManifests}: LateManifestStopsContentProps) => {
  return (
    <Container>
      <p>
        These driver&apos;s manifest(s) already has a stop projected to be late, it can not be considered. Would you
        like to remove them and continue?
      </p>
      <List>
        {lateManifests.map((manifest) => (
          <li key={manifest.manifestDriverId}>
            <DriverName>{manifest.driverName}</DriverName>
          </li>
        ))}
      </List>
    </Container>
  );
};

export default LateManifestStopsContent;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const List = styled.ul`
  margin: 0;
  padding-left: 16px;
  & > li:not(:last-of-type) {
    margin-bottom: 4px;
  }
`;

const DriverName = styled.span`
  font-style: italic;
`;
